export default __webpack_public_path__ + "fdd4e51f4f68c6e881371b7c43608a10.webp";